import { render, staticRenderFns } from "./iconDiscover.vue?vue&type=template&id=a445272c&scoped=true"
import script from "./iconDiscover.vue?vue&type=script&lang=js"
export * from "./iconDiscover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a445272c",
  null
  
)

export default component.exports